import Carousel from 'Assets/js/lib/carousel'
import { CARTSTATES } from 'Assets/js/lib/constants'
import { debounce, throttle } from 'Assets/js/lib/helpers'
;(function () {
  const components = {
    header: SAXX.Init.Component((node) => {
      const parent = node.parentNode
      const sectionHeight = () => node.offsetHeight
      const sectionRect = () => parent.getBoundingClientRect()
      const bodyRect = () => document.body.getBoundingClientRect()
      const slideAwayNavigation = node.classList.contains('slide-away')
      parent.classList.toggle('slide-away', slideAwayNavigation)

      const setSpacerVariable = () => {
        document
          .querySelector(':root')
          .style.setProperty('--header-space', `${sectionHeight() / 16}rem`)
      }

      let lastScrollDepth = 0

      const setHeaderSlideAwayState = () => {
        setSpacerVariable()
        const scrollDepth = window.scrollY

        const sectionTop = sectionRect().top - bodyRect().top
        const sectionBottom =
          sectionRect().bottom - bodyRect().top + sectionHeight()

        if (
          scrollDepth < lastScrollDepth &&
          (scrollDepth <= sectionTop || scrollDepth <= 10)
        ) {
          node.classList.remove('fixed', 'scroll-up')
          parent.classList.remove('needs-spacer')
        } else if (
          scrollDepth > lastScrollDepth &&
          scrollDepth > sectionBottom
        ) {
          node.classList.add('fixed')
          parent.classList.add('needs-spacer')
        }

        parent.classList.toggle(
          'elements-should-offset',
          scrollDepth < lastScrollDepth,
        )
        node.classList.toggle('scroll-up', scrollDepth < lastScrollDepth)

        lastScrollDepth = scrollDepth
      }

      setSpacerVariable()

      window.addEventListener('resize', debounce(setHeaderSlideAwayState, 100))

      window.addEventListener('scroll', throttle(setHeaderSlideAwayState, 25))
    }),
    cartNavigationIcon: SAXX.Init.Component((node, ctx) => {
      ctx.on(
        CARTSTATES.UPDATED,
        ({ cart = {} }, { addedLineItems } = { addedLineItems: null }) => {
          const cartLineItems = addedLineItems ?? cart.items ?? []

          node.classList.toggle('cart-has-items', cartLineItems.length > 0)
        },
      )
    }),
    mobilePromoCarousel: SAXX.Init.Component((node) => {
      new Carousel(node, { cell: '.navigation--mobile-promo' })
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
